/**
 * Agent Spend Cap Service (BL-37669b48)
 * AIDLC Administrative Backend
 *
 * One cap for every agent run: today's and this month's spend (America/Detroit) against it,
 * and the CEO's raise for the current day or month.
 */

import apiClient from './api';

export type CapPeriod = 'day' | 'month';
export type CapLevel = 'ok' | 'warning' | 'reached';

export interface PeriodCapState {
  period: CapPeriod;
  key: string;
  startsAt: string;
  spentUsd: number;
  capUsd: number;
  defaultCapUsd: number;
  pct: number;
  level: CapLevel;
  raise: { capUsd: number; raisedBy: string; raisedAt: string; reason: string } | null;
}

export interface SpendCapState {
  day: PeriodCapState;
  month: PeriodCapState;
  level: CapLevel;
  warningPct: number;
  sanityMaxUsd: Record<CapPeriod, number>;
  checkedAt: string;
}

export async function fetchSpendCap(): Promise<SpendCapState> {
  const response = await apiClient.get<SpendCapState>('/spend-cap');
  return response.data;
}

export async function raiseSpendCap(period: CapPeriod, capUsd: number, reason: string): Promise<SpendCapState> {
  const response = await apiClient.post<SpendCapState>('/spend-cap/raise', { period, capUsd, reason });
  return response.data;
}
